<script setup lang="ts">
import { X } from '@lucide/vue'
import AdaptiveOverlay from './AdaptiveOverlay.vue'

withDefaults(defineProps<{
    open: boolean
    title: string
    description: string
    confirmLabel?: string
    eyebrow?: string
    loading?: boolean
    teleportTo?: string | HTMLElement
}>(), {
    confirmLabel: '确认删除',
    eyebrow: '确认操作',
    loading: false,
})

const emit = defineEmits<{
    close: []
    confirm: []
    afterLeave: []
}>()
</script>

<template>
    <AdaptiveOverlay :open="open" :label="title" max-width="30rem" mode="dialog" :teleport-to="teleportTo" @close="emit('close')" @after-leave="emit('afterLeave')">
        <div class="p-6 sm:p-8">
            <div class="relative min-w-0">
                <p class="min-h-11 flex items-center pr-14 text-[13px] text-[var(--c-danger)] font-700 sm:text-[14px]">
                    {{ eyebrow }}
                </p>
                <button type="button" class="absolute right-0 top-0 grid size-11 place-items-center rounded-full text-[var(--c-text-muted)] transition hover:bg-[var(--c-fill-hover)] hover:text-[var(--c-text)] focus-ring" aria-label="关闭" @click="emit('close')">
                    <X class="size-5" />
                </button>
                <h2 class="mt-1 text-[1.75rem] text-[var(--c-text)] leading-tight font-editorial sm:text-3xl">
                    {{ title }}
                </h2>
            </div>
            <p class="mt-4 text-sm text-[var(--c-text-muted)] leading-6">
                {{ description }}
            </p>
            <button class="mt-7 min-h-11 w-full rounded-full bg-[#b74232] px-5 text-sm text-white font-650 transition disabled:cursor-wait hover:bg-[#cf503e] disabled:opacity-60 focus-ring" :disabled="loading" @click="emit('confirm')">
                {{ loading ? '正在处理' : confirmLabel }}
            </button>
        </div>
    </AdaptiveOverlay>
</template>
